import * as React from 'react';
import { Button as ReactStrapButton, ButtonProps as ReactStrapButtonProps, Spinner } from "reactstrap";
import BEMHelper from 'react-bem-helper';

import './Button.css';

export interface ButtonProps extends ReactStrapButtonProps {
    isLoading?: boolean;
}

const classes = new BEMHelper('ButtonElement');

const Button: React.FC<ButtonProps> = ({
    children,
    disabled = false,
    outline = false,
    primary = false,
    block = false,
    isLoading = false,
    className,
    ...rest
}) => (
    <ReactStrapButton
        {...classes(undefined, { outline, primary, block }, className)}
        disabled={disabled}
        {...rest}
    >
        <div {...classes('buttonContent')}>
            {children}
            {isLoading ? <Spinner size={'sm'} className="spinner-invert-color" /> : null}
        </div>
    </ReactStrapButton>
);

export default Button;
